// ── Screen stack ────────────────────────────
const stack = document.getElementById("screenStack");
const copyWrap = document.getElementById("screensCopy");

if (stack) {
  const positions = [
    [0, 0, 0, 1.0, 1.0],
    [6, 28, 18, 0.95, 0.75],
    [-5, -22, 30, 0.92, 0.5],
    [8, 14, 40, 0.9, 0.25],
  ];

  let currentIndex = 0;
  const totalCards = stack.children.length;

  function applyStack() {
    const cards = [...stack.children];
    cards.forEach((card, i) => {
      const [r, x, y, s, o] = positions[Math.min(i, positions.length - 1)];
      card.style.zIndex = cards.length - i;
      card.style.opacity = i < positions.length ? o : 0;
      card.style.transform =
        i === 0
          ? `translateX(-50%) rotate(${r}deg) translateY(${y}px)`
          : `translateX(calc(-50% + ${x}px)) rotate(${r}deg) translateY(${y}px) scale(${s})`;
    });
  }

  function updateCopy(index) {
    if (!copyWrap) return;
    const items = [...copyWrap.querySelectorAll(".screens-copy-item")];
    items.forEach((item, i) => {
      if (item.classList.contains("active") && i !== index) {
        item.classList.add("exit");
        item.classList.remove("active");
        setTimeout(() => item.classList.remove("exit"), 350);
      }
    });
    setTimeout(() => {
      items[index]?.classList.add("active");
    }, 200);
    const active = items[index];
    if (active) copyWrap.style.minHeight = active.scrollHeight + "px";
  }

  function advance() {
    const cards = [...stack.children];
    const top = cards[0];

    top.style.transition =
      "transform 0.45s cubic-bezier(0.4, 0, 0.6, 1), opacity 0.35s ease";
    top.style.transform = "translateX(130%) rotate(18deg) translateY(-40px)";
    top.style.opacity = "0";

    currentIndex = (currentIndex + 1) % totalCards;

    setTimeout(() => {
      top.style.transition = "none";
      top.style.transform = "translateX(-50%)";
      top.style.opacity = "0";
      stack.appendChild(top);
      void top.offsetWidth;
      top.style.transition = "";
      applyStack();
    }, 450);

    updateCopy(currentIndex);
  }

  applyStack();
  updateCopy(0);

  stack.addEventListener("click", () => {
    advance();
    resetTimer();
  });

  let timer = setInterval(advance, 6000000);
  function resetTimer() {
    clearInterval(timer);
    timer = setInterval(advance, 6000000);
  }
}

// ── Hero video (desktop only) ────────────────
const heroVideo = document.querySelector('.hero-video--bg');
if (heroVideo && window.innerWidth >= 769) {
  const src = heroVideo.dataset.src;
  if (src) {
    heroVideo.innerHTML = '<source src="' + src + '" type="video/mp4">';
    heroVideo.load();
  }
}

// ── Burger menu ─────────────────────────────
const burger = document.getElementById('burger');
const mobileMenu = document.getElementById('mobileMenu');
if (burger) {
  burger.addEventListener('click', () => {
    burger.classList.toggle('open');
    mobileMenu.classList.toggle('open');
  });
  mobileMenu.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => {
      burger.classList.remove('open');
      mobileMenu.classList.remove('open');
    });
  });
}

// ── NAV scroll effect ───────────────────────
const nav = document.getElementById("nav");
if (nav) {
  window.addEventListener("scroll", () => {
    nav.style.background = window.scrollY > 40
      ? "rgba(4,56,15,1)"
      : "rgba(6,76,21,1)";
  });
}

// ── Scroll reveal ───────────────────────────
const revealEls = document.querySelectorAll(
  ".feature-card, .screen-card, .email-text, .email-form, .section-headline, .section-eyebrow, .blog-card, .article-header, .article-content",
);
revealEls.forEach((el) => el.classList.add("reveal"));

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        setTimeout(() => entry.target.classList.add("visible"), i * 80);
        observer.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.12 },
);

revealEls.forEach((el) => observer.observe(el));

